import {requestWithToken, simpleRequest} from "../apiConfigs/request";

export const fetchJobList = (query = "") => {
  return requestWithToken({
    url: `/public/jobs${query}`,
    method: 'GET',
  });
};

export const fetchJobById = (jobId, query = "") => {
  return requestWithToken({
    url: `/public/jobs/${jobId}${query}`,
    method: 'GET',
  });
};

export const applyToJob = (jobId, data) => {
  return simpleRequest({
    url: `/public/jobs/${jobId}/apply`,
    method: 'POST',
    data,
  });
};

export const createJobApplication = (jobId, data) => {
  return simpleRequest({
    url: `/public/jobs/${jobId}/apply`,
    method: 'POST',
    data
  });
}